const LABEL = 'label';
const TARGET_CHANNEL = 'targetChannel';
const IS_ARCHIVED = 'isArchived';
const PAGE = 'page';

export { LABEL, TARGET_CHANNEL, IS_ARCHIVED, PAGE };
